import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Spin } from 'antd';
import SearchForm from './components/SearchForm'
import SearchResult from './components/SearchResult'
@inject('apiManagementStore')
@observer
class ApiManagement extends Component {
  formRef = React.createRef();
  search=(direction)=> {
    this.formRef.current.handleSearch(direction)
  }
  render() {
    const { apiManagementStore, location } = this.props
    const { isFetching } = apiManagementStore
    return (
      <Spin spinning={isFetching}>
        <div className="container">
          <SearchForm ref={this.formRef} location={location}/>
          <SearchResult search={this.search}/>
        </div>
      </Spin>
    );
  }
}
export default ApiManagement;
